<template>
  <tables
    :dataset="_dataset"
    type="keys"
    :queryParams.sync="queryParams"
    :headers="keyHeaders"
  >
    <template v-slot:content="slotProps">
      <div v-if="showMobileView">
        <v-row>
          <v-col cols="6" class="px-0 pt-0 pb-2">
            <v-card-text
              class="py-0 text-h6 font-weight-medium secondary--text"
            >
              {{ slotProps.data.code }}
            </v-card-text>
          </v-col>
          <v-col cols="6" class="px-0 py-1">
            <v-card-text
              class="text-right py-0 text-subtitle-1 text-capitalize"
            >
              {{ slotProps.data.group.address.city }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="px-0 py-1">
            <v-card-text class="pb-0 pt-2 text-subtitle-2 font-weight-medium">
              {{ slotProps.data.email }}
            </v-card-text>
          </v-col>
        </v-row>
        <div class="d-flex align-start">
          <v-card-text class="py-0 px-1 text-subtitle-2 font-weight-medium">
            {{ slotProps.data.phone }}
          </v-card-text>
          <div class="mb-n7 mt-n5 mr-n2">
            <v-checkbox
              dense
              v-model="slotProps.data.used"
              @click="$router.shouldRoute = false"
            />
          </div>
        </div>
      </div>
      <div v-if="!showMobileView" style="width:100%;">
        <v-row
          class="d-flex justify-space-between px-3"
          v-if="!showMobileView"
          style="font-size:12px;"
        >
          <div
            class="d-flex align-center"
            style="width:12%; overflow: ellipsis;"
            id="key-code"
          >
            {{ slotProps.data.code }}
          </div>
          <div
            class="d-flex align-center"
            style="width:12%; overflow: ellipsis;"
            id="key-group"
          >
            {{ slotProps.data.group.address.city }}
          </div>
          <div
            class="d-flex align-center"
            style="width:12%; overflow: hidden;"
            id="key-email"
          >
            {{ slotProps.data.email }}
          </div>
          <div
            class="d-flex align-center"
            style="width:12%; overflow: ellipsis;"
            id="key-phone"
          >
            {{ formatPhone(slotProps.data.phone) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:12%; overflow: ellipsis;"
            id="key-return"
          >
            {{ formatDate(slotProps.data.expected_return * 1000) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:12%; overflow: ellipsis;"
            id="key-created-by-"
          >
            {{ getGroupName(slotProps.data.group_id) }}
          </div>
          <div
            class="d-flex align-center"
            style="width:12%; overflow: ellipsis;"
            id="key-used"
          >
            <v-checkbox
              dense
              v-model="slotProps.data.used"
              @click="changeUsed(slotProps.data)"
            />
          </div>
        </v-row>
        <v-snackbar v-model="snackbar" :timeout="timeout">
          {{ createMessage }}
          <template v-slot:action="{ attrs }">
            <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </div>
    </template>
  </tables>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Tables from '@/components/app/Table';
import { MobileView } from '@/mixins';
import FormatPhone from '@/mixins/FormatPhone';
import FormatDate from '@/mixins/FormatDate';

export default {
  components: {
    Tables,
  },
  mixins: [MobileView, FormatPhone, FormatDate],
  data: () => ({
    keyHeaders: [
      'Key Code',
      'Creation Location',
      'Contact Email',
      'Contact Phone Number',
      'Return Date',
      'Created By',
      'Used',
    ],
    snackbar: false,
    snackbarText: false,
    timeout: 2000,
  }),
  computed: {
    ...mapGetters({
      _dataset: 'digitalKeys/getData',
      _getQueryParams: 'digitalKeys/getQueryParams',
      createMessage: 'digitalKeys/getKeyCreate',
      currentClient: 'account/getCurrentClient',
    }),
    queryParams: {
      get() {
        return this._getQueryParams;
      },
      set(val) {
        this._setQueryParams(val);
      },
    },
  },
  methods: {
    ...mapActions({
      _editKey: 'digitalKeyDetails/editKey',
    }),
    ...mapMutations({
      _setQueryParams: 'reports/setQueryParams',
      setCreateKey: 'digitalKeys/setCreateKey',
    }),
    capitalize(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    },
    getGroupName(id) {
      let screenGroup = null;
      this.currentClient.groups.map((group) => {
        if (group.uuid === id) {
          screenGroup = group;
        }
      });
      if (screenGroup) {
        return screenGroup.group_name;
      }
      return id;
    },
    changeUsed(data) {
      this.$router.shouldRoute = false;
      delete data.group;
      delete data.error;
      delete data.success;
      this._editKey(data);
    },
  },
  watch: {
    _dataset: {
      handler() {},
      deep: true,
    },
    createMessage() {
      if (this.createMessage) {
        this.snackbar = true;
      }
    },
    snackbar() {
      if (!this.snackbar) {
        this.setCreateKey(null);
      }
    },
  },
  mounted() {
    this.$router.shouldRoute = true;
  },
};
</script>
